import { Button, Col, Divider, Drawer, Flex, List, Row } from 'antd';
import { observer } from 'mobx-react';
import React, { Component, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { gamesMenu } from './HeaderBlock';
import { Logo } from './Logo';
import { UserProfile } from './UserProfile';
import { HeaderLinks } from './HeaderLinks';
import { ReactComponent as LogoIcon } from '../assets/logo.svg';
import { ReactComponent as MenuButtonIcon } from '../assets/menuButton.svg';

interface IProps extends IRootStoreProps {
  children?: ReactNode;
}

class _HeaderBlockMobile extends Component<IProps> {
  state = { open: false };
  render(): React.ReactNode {
    const showDrawer = () => {
      this.setState({ open: true });
    };

    const onClose = () => {
      this.setState({ open: false });
    };

    return (
      <>
        <Row
          style={{
            marginTop: 10,
            marginBottom: 5,
            border: '0px solid #E4E4E7',
            borderBottomWidth: 1,
            marginInline: 10,
            paddingBottom: 10,
          }}
        >
          <Col
            span={6}
            style={{
              justifyContent: 'flex-start',
              alignItems: 'center',
              display: 'flex',
            }}
          >
            <LogoIcon />
          </Col>
          <Col span={12}>
            <Flex style={{ height: '100%' }} justify={'center'} align={'center'}>
              <Logo />
            </Flex>
          </Col>
          <Col span={6} style={{ justifyContent: 'flex-end', alignItems: 'center', display: 'flex' }}>
            <Button
              onClick={showDrawer}
              style={{ borderWidth: 0 }}
              icon={<MenuButtonIcon style={{ fontSize: 20 }} />}
            />
          </Col>
        </Row>
        {this.props.children}
        <Drawer
          closable={false}
          placement={'left'}
          width={220}
          onClose={onClose}
          open={this.state.open}
          onClick={onClose}
        >
          <UserProfile />
          {this.props.store.user.isAuth && (
            <>
              <Divider orientation="left">Игры</Divider>
              <List
                dataSource={gamesMenu}
                renderItem={item => (
                  <List.Item>
                    <Link to={item.value}>
                      <Button
                        icon={item.icon}
                        iconPosition={'start'}
                        color="primary"
                        variant="filled"
                        disabled={item.disabled}
                      >
                        {item.name}
                      </Button>
                    </Link>
                  </List.Item>
                )}
              />
            </>
          )}
          <HeaderLinks gap="small" vertical style={{ marginTop: 20 }} />
        </Drawer>
      </>
    );
  }
}

export const HeaderBlockMobile: WithoutStore = withStore(observer(_HeaderBlockMobile));
